export const events = {
  openBankAccount: 'Open bank account from benefits account card',
  openBankAccountCards: 'View benefit cards linked to bank account',
  goToSupplements: 'Go to payroll supplements from benefits home page',
  goToCardPayments: 'Open card payments from benefits',
  openBenefitsAccountsPage: 'Open benefits accounts page',
  openBenefitCardInfo: 'Open benefit card info from benefits home page',
  openBenefitsHomePage: 'Open benefits home page',
  openBenefitsEmployeesPage: 'Open benefits employees page',
  openBenefitsUsagePage: 'Open benefits usage page',
  openMyBenefitsHomePage: 'Open my benefits home page',
  openMyBenefitsHelpLink: 'Open my benefits help link',
  openMyBenefitsListPage: 'Open my benefits list page',
  requestBenefit: 'Request benefit from benefits home page',
  requestChildcareBenefit: 'Request childcare benefit',
  openBenefitsLanding: 'View Benefits landing page',
  userLandsInBenefitsActivationOnboarding: 'User lands in benefits activation onboarding',
  userCompletesBenefitsActivationOnboarding: 'User completes benefits activation onboarding',
  userLandsInBenefitsActivationEmployeeSelector:
    'User lands in benefits activation employee selector',
  userLandsInBenefitsActivationCompliance: 'User lands in benefits activation compliance',
  openPerksPage: 'User lands in the benefits perks page',
  requestPerk: 'User requests perk from the benefits perks page',
  // Healthcare enrollment wizard
  openHealthcareEnrollmentWizard: 'Open healthcare enrollment wizard',
  closeHealthcareEnrollmentWizard: 'Close healthcare enrollment wizard',
  advanceToHealthcareEnrollmentPersonalInformationStep:
    'Advance to healthcare enrollment personal information step',
  openHealthcareEnrollmentPlanOverviewStep: 'Open healthcare enrollment plan overview step',
  submitHealthcareEnrollmentWizard: 'Submit healthcare enrollment',

  // Benefits settings
  openBenefitsSettingsPage: 'Open benefits settings page',
  clickSaveResetDay: 'Save new benefit cycle reset day',
  confirmResetDayChange: 'Confirm benefit cycle reset day change',
  cancelResetDayChange: 'Cancel benefit cycle reset day change',
  clickConfigureCycleDateFromAccountsPage: 'Click configure cycle date from accounts page',
}
